// extracted by mini-css-extract-plugin
module.exports = {"content":"SectorsSecondaryStep_content__1eVNK","sectorsContainer":"SectorsSecondaryStep_sectorsContainer__1470t"};